<template>
    <div class="mgui-sidebar">
        <div class="mgui-sidebar-inner">
          <svg class="icon mgui-sidebar-close" aria-hidden="true" @click="$routeTo('/');hiddenFun()">
            <use xlink:href="#icon-guanbi"></use>
          </svg>
          <div class="mgui-userinfo" v-if="!userInfo">
            <img :src="avatar(null)" :alt="userInfo.username" class="avatar">
            <span class="username">请登录</span>
          </div>
          <div class="mgui-userinfo" v-else>
            <a @click="$routeTo('/me')"><img :src="avatar(userInfo.image)" :alt="userInfo.username" class="avatar"></a>
            <p><span class="username">{{userInfo.username}}</span></p>
            <p>{{userInfo.mobile}}</p>
            <p><i-tag>{{userInfo.group_title}}</i-tag></p>
          </div>
          <div class="side-navs">
            <!-- <a class="item" @click="$routeTo('/center/financial')">
              <Icon type="social-yen-outline"></Icon>
              <span>财务中心</span>
            </a> -->
            <a class="item" @click="$routeTo('/attend/salary')">
              <Icon type="ios-calendar-outline"></Icon>
              <span>考勤薪资</span>
            </a>
            <!-- <a class="item" @click="$routeTo('/upload/data')" :disabled="$store.state.userInfo.role == 1||$store.state.userInfo.role == 2">
              <Icon type="ios-cloud-upload"></Icon>
              <span>上传数据</span>
            </a> -->
          </div>
          <div class="mgui-sidebar-foot" v-if="userInfo">
            <Button type="error" @click="logout" style="margin-bottom:15px;" long>退出</Button>
            <!--Button type="text" long @click="$routeTo('/apply/quit/post')">
              <span class="cn">我要离职</span>
            </Button-->
          </div>
          <div class="mgui-sidebar-foot" v-else>
            <Button class="mguButton block" @click="openLoginBox">登录</Button>
            <Button class="mguButton block" @click="openRegBox">注册</Button>
          </div>
          <nav class="mgui-sidebar-nav">
            <a @click="$routeTo('/me')">
              <span class="cn">个人资料</span>
            </a>
            <a @click="$routeTo('/entry?look');hiddenFun(0)">
              <span class="cn">入职资料</span>
            </a>
            <a @click="$routeTo('/attend/salary')">
              <span class="cn">考勤薪资</span>
            </a>
            <a @click="$routeTo('/me/repw')">
              <span class="cn">修改密码</span>
            </a>
            <a @click="$routeTo('/apply/leaving')">
              <span class="cn">离职证明</span>
            </a>
          </nav>
        </div>
        <transition name="bounce"
          enter-active-class="animated fadeInRight"
          leave-active-class="animated fadeOutRight"
          v-on:enter="slideEnter"
          v-on:after-leave="slideLeave">
          <div class="center-content" v-show="centerVisible">
            <keep-alive>
              <router-view></router-view>
            </keep-alive>
          </div>
        </transition>
    </div>
</template>

<script>

export default {
  name: 'UserCenter',
  components: {
  },
  data () {
    return {
      activeTab: '',
      isLogged: false,
      show: true,
      centerVisible: false
    }
  },
  watch: {
    $route (to) {
      this.routeChange(to)
    }
  },
  mounted () {
    this.$store.dispatch('setMaskShow', true)
  },
  computed: {
    userInfo: function () {
      return this.$store.state.userInfo
    }
  },
  methods: {
    routeChange (to) {
      if (to.path === '/center') this.$store.dispatch('setMaskShow', true)
    },
    avatar (image) {
      let avatar = (image === null || image === '') ? this.userInfo.headimgurl : image
      return avatar
    },
    logout () {
      this.$router.replace({'path': '/home'})
      this.$parent.spinShow = true
      this.$store.dispatch('logout')
      this.$Message.success('成功退出')
    },
    hiddenFun () {
      this.$store.dispatch('setMaskShow', false)
    },
    openLoginBox () {
      this.$store.dispatch('activeWindow', 'loginBox')
    },
    openRegBox () {
      this.$store.dispatch('activeWindow', 'regBox')
    },
    slideEnter () {
    },
    slideLeave () {
      this.$store.dispatch('setSideState', false)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .center-content{
    background: #f7f7f7;
    height: 100%;
  }
  .side-navs{
    padding: 10px;
    background: #f7f7f7;
    border: 1px solid #eee;
  }
  .side-navs .item{
    width: 25%;
    height: 40px;
    display: inline-block;
    text-align: center;
  }
  .side-navs .item .ivu-icon{
    width: 40px;
    border: 1px solid #ddd;
    border-radius: 40px;
    background: #fff;
    font-size: 20px;
    display: inline-block;
    line-height: 40px;
  }
  .side-navs .item>span{display:inline-block;}
  .mgui-sidebar{
    position: fixed;
    width: 100%;
    height: 100%;
    right: 0;
    top: 0;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 997;
  }
  .mgui-sidebar-inner{
    width: 300px;
    height: 100%;
    background-color: #fff;
    position: absolute;
    right: 0;
    z-index: 998;
  }
  .mgui-sidebar-foot{
    width: 100%;
    position: absolute;
    bottom: 0;
    padding: 15px;
  }
  .mgui-sidebar-close{
    position: absolute;
    top: 15px;
    right: 15px;
    fill: #999;
    cursor: pointer;
    transition: .5s 0s all ease;
    -webkit-transition: .5s 0s all ease;
    width: 20px;
    height: 20px;
  }
  .mgui-sidebar-close:hover{
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }

  .mgui-sidebar .mgui-userinfo{
    text-align: center;
    padding: 40px 40px 20px;
    color:#333;line-height: 40px;
  }
  .mgui-sidebar .mgui-userinfo p{
    margin: 0;
    line-height: 20px;
  }
  .mgui-sidebar .mgui-userinfo a{
    display: block;
    margin-bottom: 10px;
  }

  .mgui-sidebar-nav a{
    display: block;
    text-decoration: none;
    padding: 10px 15px;
    color: #333;
    position: relative;
    cursor: pointer;
    transition: .5s 0s all ease;
    -webkit-transition: .5s 0s all ease;
  }
  .mgui-sidebar-nav a:hover{
    background-color: #f7f7f7
  }
  .mgui-sidebar-nav a:after{
    position: absolute;
    bottom: 0;
    left: 15px;
    right: 15px;
    content: '';
    height: 1px;
    display: block;
    background-color: #ddd;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
  }
  .mgui-sidebar-nav a span{
    display: block
  }
  .mgui-sidebar-nav a span.en{
    font-size: 12px;
    color: #999;
  }
  .mgui-sidebar-nav a span.cn{
    font-size: 14px;
  }
  .mgui-sidebar-button{
    padding: 15px;
  }
  .mgui-userinfo .username{
    display: inline-block;
    padding: 0 10px;
  }
  .mgui-userinfo .avatar{
    width: 80px;
    height: 80px;
    border-radius: 80px;
    display: block;
    margin: 0 auto;
    overflow: hidden;
  }
  .mgui-header .login-info{
    line-height: 41px;
    color: #ccc;
  }
  .mgui-header .login-info a{
    font-size: 13px;
    text-decoration: none;
    margin: 0 5px;
  }
  .slide-enter-active {
    height: 100%;
    animation: slide-in .5s;
  }
  .slide-leave-active {
    animation: slide-in .5s reverse;
  }
</style>
